/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for PartnerCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { PartnerDto, RequestOptions, MerchantCategorie, PagedModelPartnerDto } from "../models";

@Injectable({ providedIn: "root" })
export class PartnerCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    createPartner(partnerDto: PartnerDto, observe?: 'body', options?: RequestOptions<'text'>): Observable<string>;
    createPartner(partnerDto: PartnerDto, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<string>>;
    createPartner(partnerDto: PartnerDto, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<string>>;
    createPartner(partnerDto: PartnerDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/partners`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: partnerDto,
            observe,
            headers,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    editPartner(partnerDto: PartnerDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    editPartner(partnerDto: PartnerDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    editPartner(partnerDto: PartnerDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    editPartner(partnerDto: PartnerDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/partners`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: partnerDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    createPartner1(partnerDto: PartnerDto, observe?: 'body', options?: RequestOptions<'text'>): Observable<string>;
    createPartner1(partnerDto: PartnerDto, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<string>>;
    createPartner1(partnerDto: PartnerDto, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<string>>;
    createPartner1(partnerDto: PartnerDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/partners`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: partnerDto,
            observe,
            headers,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    editPartner1(partnerDto: PartnerDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    editPartner1(partnerDto: PartnerDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    editPartner1(partnerDto: PartnerDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    editPartner1(partnerDto: PartnerDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/partners`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: partnerDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getPartnerDetails(idPartner: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<PartnerDto>;
    getPartnerDetails(idPartner: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PartnerDto>>;
    getPartnerDetails(idPartner: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PartnerDto>>;
    getPartnerDetails(idPartner: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/partners/${idPartner}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getPartnerDetails1(idPartner: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<PartnerDto>;
    getPartnerDetails1(idPartner: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PartnerDto>>;
    getPartnerDetails1(idPartner: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PartnerDto>>;
    getPartnerDetails1(idPartner: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/partners/${idPartner}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getPartnerTypes(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<'SYSTEM' | 'MERCHANT' | 'PROVIDER'>>;
    getPartnerTypes(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<'SYSTEM' | 'MERCHANT' | 'PROVIDER'>>>;
    getPartnerTypes(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<'SYSTEM' | 'MERCHANT' | 'PROVIDER'>>>;
    getPartnerTypes(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/partners/types`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getPartnerTypes1(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<'SYSTEM' | 'MERCHANT' | 'PROVIDER'>>;
    getPartnerTypes1(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<'SYSTEM' | 'MERCHANT' | 'PROVIDER'>>>;
    getPartnerTypes1(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<'SYSTEM' | 'MERCHANT' | 'PROVIDER'>>>;
    getPartnerTypes1(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/partners/types`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getParents(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<PartnerDto>>;
    getParents(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<PartnerDto>>>;
    getParents(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<PartnerDto>>>;
    getParents(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/partners/parents`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getParents1(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<PartnerDto>>;
    getParents1(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<PartnerDto>>>;
    getParents1(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<PartnerDto>>>;
    getParents1(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/partners/parents`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllMcc(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<MerchantCategorie>>;
    getAllMcc(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<MerchantCategorie>>>;
    getAllMcc(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<MerchantCategorie>>>;
    getAllMcc(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/partners/mcc`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllMcc1(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<MerchantCategorie>>;
    getAllMcc1(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<MerchantCategorie>>>;
    getAllMcc1(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<MerchantCategorie>>>;
    getAllMcc1(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/partners/mcc`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getChildren(idPartner: number, partnerType?: 'SYSTEM' | 'MERCHANT' | 'PROVIDER', page?: number, size?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelPartnerDto>;
    getChildren(idPartner: number, partnerType?: 'SYSTEM' | 'MERCHANT' | 'PROVIDER', page?: number, size?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelPartnerDto>>;
    getChildren(idPartner: number, partnerType?: 'SYSTEM' | 'MERCHANT' | 'PROVIDER', page?: number, size?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelPartnerDto>>;
    getChildren(idPartner: number, partnerType?: 'SYSTEM' | 'MERCHANT' | 'PROVIDER', page?: number, size?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/partners/children/${idPartner}`;

        let params = new HttpParams();
        if (partnerType != null) {
            params = HttpParamsBuilder.addToHttpParams(params, partnerType, 'partnerType');
        }
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getChildren1(idPartner: number, partnerType?: 'SYSTEM' | 'MERCHANT' | 'PROVIDER', page?: number, size?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelPartnerDto>;
    getChildren1(idPartner: number, partnerType?: 'SYSTEM' | 'MERCHANT' | 'PROVIDER', page?: number, size?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelPartnerDto>>;
    getChildren1(idPartner: number, partnerType?: 'SYSTEM' | 'MERCHANT' | 'PROVIDER', page?: number, size?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelPartnerDto>>;
    getChildren1(idPartner: number, partnerType?: 'SYSTEM' | 'MERCHANT' | 'PROVIDER', page?: number, size?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/partners/children/${idPartner}`;

        let params = new HttpParams();
        if (partnerType != null) {
            params = HttpParamsBuilder.addToHttpParams(params, partnerType, 'partnerType');
        }
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getPartnerByMcc(mcc: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<PartnerDto>>;
    getPartnerByMcc(mcc: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<PartnerDto>>>;
    getPartnerByMcc(mcc: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<PartnerDto>>>;
    getPartnerByMcc(mcc: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/public/partners/by-mcc`;

        let params = new HttpParams();
        if (mcc != null) {
            params = HttpParamsBuilder.addToHttpParams(params, mcc, 'mcc');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getPartnerByMcc1(mcc: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<PartnerDto>>;
    getPartnerByMcc1(mcc: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<PartnerDto>>>;
    getPartnerByMcc1(mcc: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<PartnerDto>>>;
    getPartnerByMcc1(mcc: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/partners/by-mcc`;

        let params = new HttpParams();
        if (mcc != null) {
            params = HttpParamsBuilder.addToHttpParams(params, mcc, 'mcc');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
